import Vue from 'vue'
import VueRouter from 'vue-router'
import permissionConstant from '@/constants/permissions.js'
import store from '../store'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/',
        redirect: '/dashboard',
        meta: {
            requiresAuth: true,
            permission: [
                permissionConstant.inquiry.view,
                permissionConstant.attendance.view
            ]
        }
    },
    {
        path: '/liff-leave',
        name: 'LeaveApplication',
        component: () => import('../views/Liff/LeaveApplication.vue')
    },
    {
        path: '/checkin-onsite',
        name: 'CheckinOnSite',
        component: () => import('../views/Liff/CheckinOnSite'),
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/approval-inquiry',
        name: 'ApprovalInquiry',
        component: () => import('../views/Liff/ApprovalInquiry'),
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/approval-overtime',
        name: 'OvertimeReview',
        component: () => import('../views/Liff/OvertimeReview.vue'),
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/group-attendace-detail',
        name: 'GroupAttendaceDetail',
        component: () => import('../views/Liff/GroupAttendaceDetail'),
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/overtime-request',
        name: 'LineOvertimeRequest',
        component: () => import('../views/Liff/OvertimeRequest'),
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/checkin-by-line',
        name: 'CheckIn',
        component: () => import('../views/Liff/CheckIn'),
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/primary',
        name: 'Primary',
        component: () => import('../views/Primary.vue'),
        children: [
            {
                path: '/dashboard',
                name: 'Dashboard',
                component: () => import('../views/Dashboard.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [
                        permissionConstant.inquiry.view,
                        permissionConstant.attendance.view
                    ]
                }
            },
            {
                path: '/inquiry-and-attendance',
                name: 'InquiryAndAttendance',
                component: () => import('../views/InquiryAndAttendance/InquiryAndAttendance.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [
                        permissionConstant.inquiry.view,
                        permissionConstant.attendance.view
                    ]
                },
                children: [
                    {
                        path: 'inquiry',
                        name: 'Inquiry',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                permissionConstant.inquiry.view
                            ]
                        }
                    },
                    {
                        path: 'manage-attendance',
                        name: 'ManageAttendance',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                permissionConstant.attendance.view
                            ]
                        }
                    },
                    {
                        path: 'status-attendance',
                        name: 'StatusAttendance',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                permissionConstant.attendance.view
                            ]
                        }
                    },
                    {
                        path: 'overtime-request',
                        name: 'OvertimeRequest',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                permissionConstant.attendance.view
                            ]
                        }
                    },
                    {
                        path: 'punch-log',
                        name: 'PunchLog',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                permissionConstant.punchlog.view
                            ]
                        }
                    },
                    {
                        path: 'check-in-location',
                        name: 'CheckInLocation',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                permissionConstant.attendance.view
                            ]
                        }
                    }
                ]
            },
            {
                path: '/inquiry/review/:id?',
                name: 'InquiryForm',
                component: () => import('../views/InquiryAndAttendance/InquiryForm.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [
                        permissionConstant.inquiry.update
                    ]
                }
            },
            {
                path: '/inquiry-and-attendance/overtime-request/:id',
                name: 'OvertimeRequestForm',
                component: () => import('../views/InquiryAndAttendance/OvertimeRequestForm.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [permissionConstant.inquiry.update]
                }
            },
            {
                path: '/attendance/manage/:id',
                name: 'AttendanceForm',
                component: () => import('../views/InquiryAndAttendance/AttendanceForm.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [
                        permissionConstant.attendance.update
                    ]
                }
            },
            {
                path: '/inquiry-and-attendance/check-in-location/:id',
                name: 'CheckInLocationDetail',
                component: () => import('../views/InquiryAndAttendance/CheckInLocationDetail.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [
                        permissionConstant.attendance.view
                    ]
                }
            },
            {
                path: '/employees',
                name: 'Employees',
                component: () => import('../views/Employee/Employees.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [permissionConstant.employee.view]
                }
            },
            {
                path: '/pin',
                name: 'Pin',
                component: () => import('../views/Pin.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [permissionConstant.employee.view]
                }
            },
            {
                path: '/message',
                name: 'Message',
                component: () => import('../views/Message/BillboardAndIndividual.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [
                        // permissionConstant.billboard.view,
                        // permissionConstant.individual.view
                    ]
                },
                children: [
                    {
                        path: 'billboard',
                        name: 'Billboard',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                // permissionConstant.billboard.view
                            ]
                        }
                    },
                    {
                        path: 'individual',
                        name: 'Individual',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                // permissionConstant.individual.view
                            ]
                        }
                    }
                ]
            },
            {
                path: '/report',
                name: 'Report',
                component: () => import('../views/Report.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [permissionConstant.report.view]
                },
                children: [
                    {
                        path: 'daily',
                        name: 'Daily',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                //
                            ]
                        }
                    },
                    {
                        path: 'visitor-report-daily',
                        name: 'VisitorDaily',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                //
                            ]
                        }
                    }
                ]
            },
            {
                path: '/time-table-setting',
                name: 'TimeTableSetting',
                component: () => import('../views/TimeTableSetting/TimeTableSetting.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [
                        permissionConstant.groupWorkday.view,
                        permissionConstant.specialWorkday.view,
                        permissionConstant.groupHoliday.view
                    ]
                },
                children: [
                    {
                        path: 'group-workday',
                        name: 'GroupNormalWorkday',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                permissionConstant.groupWorkday.view
                            ]
                        }
                    },
                    {
                        path: 'special-workday',
                        name: 'SpecialWorkday',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                permissionConstant.specialWorkday.view
                            ]
                        }
                    },
                    {
                        path: 'group-holiday',
                        name: 'GroupHoliday',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                permissionConstant.groupHoliday.view
                            ]
                        }
                    }
                ]
            },
            {
                path: '/visitors',
                name: 'Visitor',
                component: () => import('../views/Visitor/Visitor.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [permissionConstant.visitor.view]
                }
            },
            {
                path: '/visitor/form/:id?',
                name: 'VisitorForm',
                component: () => import('../views/Visitor/VisitorForm.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [
                        permissionConstant.visitor.create,
                        permissionConstant.visitor.update
                    ]
                }
            },
            {
                path: '/visitor/history/:id',
                name: 'VisitorHistory',
                component: () => import('../views/Visitor/VisitorHistory.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [
                        permissionConstant.visitor.create,
                        permissionConstant.visitor.update
                    ]
                }
            },
            {
                path: '/company/setting',
                name: 'CompanySetting',
                component: () => import('../views/CompanySetting.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [
                        permissionConstant.company.view,
                        permissionConstant.branch.view,
                        permissionConstant.department.view,
                        permissionConstant.companyHoliday.view,
                        permissionConstant.lineService.update,
                        permissionConstant.userManagement.superAdmin.view,
                        permissionConstant.userManagement.admin.view,
                        permissionConstant.userManagement.hr.view,
                        permissionConstant.blacklist.view
                    ]
                },
                children: [
                    {
                        path: 'company-profile',
                        name: 'CompanyProfile',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                permissionConstant.company.view
                            ]
                        }
                    },
                    {
                        path: 'branches',
                        name: 'BranchList',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                permissionConstant.branch.view
                            ]
                        }
                    },
                    {
                        path: 'user-list',
                        name: 'UserList',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                permissionConstant.userManagement.superAdmin.view,
                                permissionConstant.userManagement.admin.view,
                                permissionConstant.userManagement.hr.view
                            ]
                        }
                    },
                    {
                        path: 'departments',
                        name: 'DepartmentList',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                permissionConstant.department.view
                            ]
                        }
                    },
                    {
                        path: 'line-service',
                        name: 'LineService',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                permissionConstant.lineService.update
                            ]
                        }
                    },
                    {
                        path: 'company-holiday',
                        name: 'CompanyHolidays',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                permissionConstant.companyHoliday.view
                            ]
                        }
                    },
                    {
                        path: 'leave-quota',
                        name: 'LeaveQuota',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                permissionConstant.leaveQuota.view
                            ]
                        }
                    },
                    {
                        path: 'save-place',
                        name: 'SavePlace',
                        meta: {
                            requiresAuth: false,
                            permission: [
                                permissionConstant.blacklist.view
                            ]
                        }
                    },
                    {
                        path: 'blacklist',
                        name: 'Blacklist',
                        meta: {
                            requiresAuth: true,
                            permission: [
                                permissionConstant.blacklist.view
                            ]
                        }
                    }
                ]
            },
            {
                path: '/employee/form/:id?',
                name: 'EmployeeForm',
                component: () => import('../views/Employee/EmployeeForm.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [
                        permissionConstant.employee.create,
                        permissionConstant.employee.update
                    ]
                }
            },
            {
                path: '/blacklist/form/:id?',
                name: 'BlacklistForm',
                component: () => import('../views/Blacklist/BlacklistForm.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [
                        permissionConstant.blacklist.create,
                        permissionConstant.blacklist.update
                    ]
                }
            },
            {
                path: '/employee/import',
                name: 'EmployeeImport',
                component: () => import('../views/Employee/EmployeeImport.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [
                        permissionConstant.employee.create,
                        permissionConstant.employee.update
                    ]
                }
            },
            {
                path: '/time-table-setting/group-workday/create',
                name: 'TimeTableSetting/CreateGroupWorkday',
                component: () => import('../views/TimeTableSetting/GroupWorkdayForm.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [permissionConstant.groupWorkday.create]
                }
            },
            {
                path: '/time-table-setting/group-workday/edit/:id',
                name: 'TimeTableSetting/EditGroupWorkday',
                component: () => import('../views/TimeTableSetting/GroupWorkdayForm.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [permissionConstant.groupWorkday.update]
                }
            },
            {
                path: '/no-permission',
                name: 'NoPermission',
                component: () => import('../views/NoPermission.vue')
            },
            {
                path: '/user-profile',
                name: 'UserProfile',
                component: () => import('../views/UserProfile.vue')
            },
            {
                path: '/devices',
                name: 'Devices',
                component: () => import('../views/Devices.vue'),
                meta: {
                    requiresAuth: true,
                    permission: [permissionConstant.device.view]
                }
            }
        ]
    },
    {
        path: '*',
        component: () => import('../views/NotFound.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        const { permission } = to.meta
        if (localStorage.getItem('jwt')) {
            store.dispatch('getPermissions').then(async () => {
                if (store.state.permissions.length !== 0) {
                    if ((permission.length > 0) && (!permission.some(p => store.state.permissions.includes(p)))) {
                        next({ path: '/no-permission' })
                    } else {
                        await store.dispatch('getBranches')
                        next()
                    }
                }
            })
        } else {
            next({
                path: '/login'
            })
        }
    } else {
        next()
    }
})

export default router
